/* eslint-disable react/prop-types */
import defaultImg from '@assets/default_img.svg';
import { getValidPrice } from '@/utils';
import classes from './ProductItem.module.css';

export const ProductItem = ({
  item, className = '', currency, customerCurrencySymbol = '$',
}) => {
  if (!item) {
    return null;
  }

  const {
    image = '',
    name = '',
    quantity = 0,
    sku = '',
    unitPrice = '',
    finalUnitPrice = '',
  } = item;

  return (
    <div className={`${classes.coverageItem} ${className}`}>
      <div className={classes.imageBlock}>
        <img
          className={classes.image}
          src={image || defaultImg}
          alt=""
          onError={(e) => {
            const img = e.currentTarget;
            img.src = defaultImg;
            img.οnerrοr = null;
          }}
        />
      </div>
      <div className={classes.detail}>
        {name ? <section className={classes.detailText}>{name}</section> : null}
        {sku ? <section className={classes.detailText}>{`SKU: ${sku}`}</section> : null}
      </div>
      <div className={classes.price}>
        {finalUnitPrice ? <section>{`${customerCurrencySymbol}${getValidPrice(finalUnitPrice)} ${currency}`}</section> : null}
        {
          unitPrice && unitPrice !== finalUnitPrice
            ? <section className={classes.deletePrice}>{`${customerCurrencySymbol}${getValidPrice(unitPrice)} ${currency}`}</section>
            : null
        }
        <section className={classes.quantity}>{` x ${quantity}`}</section>
      </div>
    </div>
  );
};
